var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "report", class: _vm.theme },
    [
      _vm.theme == "blue" && _vm.showIndex == 0
        ? _c("div", { staticClass: "right-top" }, [
            _vm.jsonData.openEng == 1
              ? _c("div", { staticClass: "content" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: { src: require("../assets/image/red/search.png") },
                    on: { click: _vm.toSearch },
                  }),
                  _c("div", { staticClass: "line" }, [_vm._v("|")]),
                  _vm.language === "zh"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/red/english.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("en")
                          },
                        },
                      })
                    : _vm.language === "en"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/red/chinese.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("zh")
                          },
                        },
                      })
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "content2" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: { src: require("../assets/image/red/search.png") },
                    on: { click: _vm.toSearch },
                  }),
                ]),
          ])
        : _vm.theme == "blue" && _vm.showIndex == 1
        ? _c("div", { staticClass: "right-top blue-bg" }, [
            _vm.jsonData.openEng == 1
              ? _c("div", { staticClass: "content" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: {
                      src: require("../assets/image/blue/search_lan.png"),
                    },
                    on: { click: _vm.toSearch },
                  }),
                  _c("div", { staticClass: "line" }, [_vm._v("|")]),
                  _vm.language === "zh"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/blue/english_lan.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("en")
                          },
                        },
                      })
                    : _vm.language === "en"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/blue/chinese_lan.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("zh")
                          },
                        },
                      })
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "content2" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: {
                      src: require("../assets/image/blue/search_lan.png"),
                    },
                    on: { click: _vm.toSearch },
                  }),
                ]),
          ])
        : _vm.theme == "yellow"
        ? _c("div", { staticClass: "right-top-y yellow-bg" }, [
            _vm.jsonData.openEng == 1
              ? _c("div", { staticClass: "content-y" }, [
                  _vm.language === "zh"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/yellow/english.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("en")
                          },
                        },
                      })
                    : _vm.language === "en"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/yellow/chinese.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("zh")
                          },
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "line" }, [_vm._v("—")]),
                  _c("img", {
                    staticClass: "search",
                    attrs: {
                      src: require("../assets/image/yellow/search.png"),
                    },
                    on: { click: _vm.toSearch },
                  }),
                ])
              : _c("div", { staticClass: "content2-y" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: {
                      src: require("../assets/image/yellow/search.png"),
                    },
                    on: { click: _vm.toSearch },
                  }),
                ]),
          ])
        : _c("div", { staticClass: "right-top" }, [
            _vm.jsonData.openEng == 1
              ? _c("div", { staticClass: "content" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: { src: require("../assets/image/red/search.png") },
                    on: { click: _vm.toSearch },
                  }),
                  _c("div", { staticClass: "line" }, [_vm._v("|")]),
                  _vm.language === "zh"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/red/english.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("en")
                          },
                        },
                      })
                    : _vm.language === "en"
                    ? _c("img", {
                        staticClass: "language",
                        attrs: {
                          src: require("../assets/image/red/chinese.png"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeLan("zh")
                          },
                        },
                      })
                    : _vm._e(),
                ])
              : _c("div", { staticClass: "content2" }, [
                  _c("img", {
                    staticClass: "search",
                    attrs: { src: require("../assets/image/red/search.png") },
                    on: { click: _vm.toSearch },
                  }),
                ]),
          ]),
      _vm.showPage && !_vm.isLongChart
        ? _c(
            "swiper",
            {
              ref: "mySwiper",
              attrs: { options: _vm.swiperOptions },
              on: { slideChange: _vm.slideChange },
            },
            [
              _c("swiper-slide", [_c("Home")], 1),
              this.menuData.length > 0
                ? _c(
                    "swiper-slide",
                    [
                      _vm.showPages
                        ? _c("Pages", {
                            ref: "pages",
                            on: { goToHomeSlide: _vm.goToHomeSlide },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
      !_vm.isLongChart
        ? _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showIndex == 0,
                expression: "showIndex == 0",
              },
            ],
            staticClass: "swiper-button-next swiper-button-next1",
            attrs: { slot: "button-next" },
            slot: "button-next",
          })
        : _vm._e(),
      !_vm.isLongChart
        ? _c("SearchDialog", {
            attrs: { show: _vm.showSearch },
            on: {
              "update:show": function ($event) {
                _vm.showSearch = $event
              },
            },
          })
        : _vm._e(),
      _vm.isLongChart
        ? _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c("Home", { attrs: { id: "page" } }),
              _c(
                "div",
                { staticStyle: { display: "flex" } },
                _vm._l(_vm.menuData, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.key,
                      staticClass: "pages",
                      class: [
                        _vm.theme != "blue" && _vm.theme != "yellow"
                          ? "pt"
                          : "",
                      ],
                      staticStyle: { flex: "0 0 auto" },
                      attrs: { id: "page" + index },
                    },
                    [
                      _c("Header"),
                      _c(item.key, {
                        tag: "component",
                        attrs: { index: index },
                      }),
                      _c("Footer"),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }